import Vue from 'vue';
import Vuex from 'vuex';
import * as types from '@/store/mutationTypes';

import { modules } from '@/store/modules';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isMobile: false
    },

    getters: {
        isMobile: state => state.isMobile
    },

    mutations: {
        [types.SET_IS_MOBILE](state, isMobile) {
            state.isMobile = isMobile;
        }
    },

    actions: {
        mobileView: ({ commit }) => {
            commit(types.SET_IS_MOBILE, true);
        },

        desktopView: ({ commit }) => {
            commit(types.SET_IS_MOBILE, false);
        }
    },

    modules
});


// WEBPACK FOOTER //
// ./src/store/store.js